import { Skeleton } from 'antd';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';

import AvatarGroup from '@/components/AvatarGroup';
import DatePreview from '@/components/DatePreview';
import TagList from '@/components/TagList';
import User from '@/components/User';
import { showPrice } from '@/utils/utils';

const Cell = ({ children, ...props }) => {
  return <span {...props}>{children}</span>;
};

export const cellRender = (value, record, index, type, render, { setting, conditionalProps, ...restOptions }) => {
  if (record.__isLoading) {
    if (type === 'image')
      return <Skeleton.Image/>;
    return <Skeleton paragraph={false} active className={'skeleton-title-m-0'}/>;
  }
  const morePros = conditionalProps ? conditionalProps(record) : {};
  if (typeof render === 'function')
    return render(value, record, index);
  switch (type) {
    case 'user':
      return <Cell type={type} value={value} {...setting} key={index}><User user={value} {...setting}/></Cell>;
    case 'user-list':
      return <Cell type={type} value={value} key={index}><AvatarGroup {...setting} users={value}/></Cell>;
    case 'money':
      return <Cell {...setting} {...morePros} key={index}>{showPrice(value, restOptions.currency)}</Cell>;
    case 'list':
      return <TagList value={value} {...setting} key={index}/>;
    case 'date':
      return <Cell {...setting} {...morePros} key={index}>
        <DatePreview value={value} format={setting?.format || 'll'}/>
      </Cell>;
    case 'time-pass':
      return <Cell {...setting} {...morePros} key={index}>{moment(value).fromNow()}</Cell>;
    default:
      return value;
  }
};

Cell.propTypes = {
  children: PropTypes.any
};
